import styled from 'styled-components';

const Image = styled.img`
  width: 40px;
  height: 40px;

  margin-inline: 1.5rem;
`;

export default Image;
